import AuthRequest from '@/shared/infrastructure/auth/Request'

const actions = {
  async register({ commit }, payload) {
    const response = await AuthRequest.register(payload)
    if (response.result) {
      commit('userLoggedIn', {response})
      commit('openAuthModal', false)
    }
    return response
  },
  async registerWithLinkedin({ commit }, payload) {
    const response = await AuthRequest.registerWithLinkedin(payload)
    if (response.result) {
      commit('userLoggedIn', {response})
      commit('openAuthModal', false)
    }
    return response
  },
  async login({ commit }, payload) {
    const response = await AuthRequest.login(payload.formData)
    if (response.result) {
      commit('userLoggedIn', { response, rememberMe: payload.rememberMe })
      commit('openAuthModal', false)
    }
    return response
  },
  // async updateCookies({commit}, payload) {
  //   if (response.result) {
  //     commit('userLoggedIn', { response, rememberMe: payload.rememberMe })
  //     commit('openAuthModal', false)
  //   }
  //   return response
  // },
  async logout({ commit, state }) {
    const { result } = await AuthRequest.logout(state.userAuthInfo.token)
    commit('userLoggedOut')
    commit('removeReferralCode')
    return result
  },
  forgotPassword(action, email) {
    return AuthRequest.forgotPassword(email)
  },
  resetPassword(action, payload) {
    return AuthRequest.resetPassword(payload.id, payload.token, payload.formData)
  },
  changePassword(action, payload) {
    return AuthRequest.changePassword(payload)
  },
  loginWithLinkedIn() {
    return AuthRequest.loginWithLinkedIn()
  },
  storeUserAuthInfo({ commit }, payload) {
    commit('userLoggedIn', { response: payload, rememberMe: false })
  },

  storeFromVuexFreelancer({ commit }, payload) {
    commit('userLoggedInFromfreelancerVuex', { response: payload })
  },

  async validateAuthToken({ commit, state }) {
    if (!state.isUserLoggedIn) return
    const response = await AuthRequest.validateAuthToken()
    if (!response.result) commit('userLoggedOut')
  },
  openAuthModal({ commit }, payload) {
    commit('openAuthModal', payload)
  },
  setAuthTabModal({ commit }, payload) {
    commit('setAuthTabModal', payload)
    commit('openAuthModal', true)
  },
  openAlertModal({ commit }, payload) {
    commit('openAlertModal', payload)
  },
  openLoginModal({commit}, payload) {
    commit('openLoginModal', payload)
  },
  openLoginSelectionModal({commit}, payload) {
    commit('openLoginSelectionModal', payload)
  },
  LoginSelectionMode({commit}, payload) {
    commit('LoginSelectionMode', payload)
  },
  openSignupSelectionModal({commit}, payload) {
    commit('openSignupSelectionModal', payload)
  },
  openForgetPasswordModal({commit}, payload) {
    commit('openForgetPasswordModal', payload)
  }
}

export default actions